import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)


/*
 * Featherlight // $ npm i featherlight
*/
import featherlight from "featherlight";


/*
 * 予告編モーダル出力: Featherlight
*/
// ---- provider/id 抽出（流用） ----
function parseProviderAndId(src) {
  let m = src.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/i)
        || src.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i)
        || src.match(/youtube\.com\/watch\?v=([A-Za-z0-9_-]{6,})/i);
  if (m) return { provider: 'youtube', id: m[1] };

  m = src.match(/vimeo\.com\/video\/(\d+)/i) || src.match(/vimeo\.com\/(\d+)/i);
  if (m) return { provider: 'vimeo', id: m[1] };

  return { provider: 'unknown', id: null };
}

// ---- oEmbed で比率取得（流用） ----
async function fetchOEmbedRatio(provider, id, signal) {
  try {
    let url = null;
    if (provider === 'youtube') {
      url = `https://www.youtube.com/oembed?url=${encodeURIComponent(`https://www.youtube.com/watch?v=${id}`)}&format=json`;
    } else if (provider === 'vimeo') {
      url = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${id}`)}`;
    }
    if (!url) return null;

    const res = await fetch(url, { mode: 'cors', signal });
    if (!res.ok) return null;
    const data = await res.json();
    if (+data.width > 0 && +data.height > 0) {
      return data.width / data.height;
    }
  } catch (_) {}
  return null;
}

// ---- 比率を既存プリセットクラスへ丸める（流用） ----
function classifyRatioClass(r) {
  const presets = [
    { r: 16/9, cls: 'ratio-16x9' },
    { r: 9/16, cls: 'ratio-9x16' },
    { r: 4/3,  cls: 'ratio-4x3'  },
    { r: 1,    cls: 'ratio-1x1'  },
  ];
  let best = presets[0], min = Infinity;
  for (const p of presets) {
    const d = Math.abs(r - p.r);
    if (d < min) { min = d; best = p; }
  }
  return best.cls;
}

// ---- クリック起動：自前HTMLを渡す方式に変更 ----
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-featherlight-video');
  if (!btn) return;
  if (btn.hasAttribute('data-featherlight')) return; // 自動バインドは別処理に任せる

  e.preventDefault();

  const src    = btn.dataset.src;
  const width  = parseInt(btn.dataset.width || '1280', 10);
  const height = parseInt(btn.dataset.height || '720', 10);

  // 1) まずは 16:9 のラッパー + iframe を自前生成（ここで確実に wrapper を得る）
  const $wrap = $('<div/>', { class: 'embed-video ratio-16x9' });
  const $iframe = $('<iframe/>', {
    src: src,
    width: width,
    height: height,
    allow: 'autoplay; encrypted-media; fullscreen; picture-in-picture',
    // allowfullscreen: 'allowfullscreen',
    loading: 'lazy',
    class: 'featherlight-inner' // 見た目維持のため（任意）
  });
  $wrap.append($iframe);

  // 2) 自前HTMLをそのまま Featherlight へ
  const ac = new AbortController(); // oEmbedの中断用
  $.featherlight($wrap, {
    variant: 'featherlight-trailer', // 任意の見た目用クラス

    afterOpen: function () {
      // 3) 並行で oEmbed → 比率クラス差し替え（成功時のみ）
      const { provider, id } = parseProviderAndId(src);
      if (!id) return;

      const timeout = new Promise(res => setTimeout(() => res(null), 2000));
      Promise.race([fetchOEmbedRatio(provider, id, ac.signal), timeout]).then((r) => {
        if (!r) return;               // 失敗/タイムアウト → 16:9のまま
        const klass = classifyRatioClass(r);
        // ratio-* を差し替え
        const others = ($wrap.attr('class') || '')
          .split(/\s+/).filter(c => c && !/^ratio-/.test(c));
        others.push(klass);
        $wrap.attr('class', others.join(' '));
      });
    },

    beforeClose: function () {
      ac.abort();                     // oEmbed中断
      $iframe.attr('src', 'about:blank'); // 確実に停止
    }
  });
});


/*
 * 2) クリックで Featherlight モーダル（枚数＋カート追加）
 *
 * 既に Featherlight を読み込んでいる前提（jQuery あり）。
 * 選択（select 連動&change発火）はこれまで通り実行し、その後モーダルを出します。
*/
/*
document.addEventListener('DOMContentLoaded', function () {
  // 既存の click ハンドラ内の最後に「モーダルを開く」を追加してOK
  document.body.addEventListener('click', function (e) {
    const a = e.target.closest('.wc-showtime-list .showtime-item');
    if (!a) return;

    // 既存の処理で select.value セット & change 発火 & active付与 …の直後に追加:
    // --- モーダル開始 ---
    if (typeof jQuery === 'undefined' || typeof jQuery.featherlight === 'undefined') return;

    const box     = a.closest('.wc-showtime-list');
    const form    = a.closest('form') || document.querySelector('form.cart, form.variations_form');
    if (!form) return;

    const whenISO = a.getAttribute('data-datetime') || '';
    const timeEl  = a.querySelector('.time');
    const priceEl = a.querySelector('.price');
    const stockEl = a.querySelector('.stock');
    const descEl  = a.querySelector('.description');

    // 見出し（YYYY/MM/DD（曜） HH:MM）
    const heading = (function () {
      try {
        if (!whenISO) return timeEl ? timeEl.textContent.trim() : '';
        const dt = new Date(whenISO);
        const youbi = ['日','月','火','水','木','金','土'][dt.getDay()];
        const pad = n => String(n).padStart(2,'0');
        return `${dt.getFullYear()}/${pad(dt.getMonth()+1)}/${pad(dt.getDate())}（${youbi}） ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
      } catch(_) { return timeEl ? timeEl.textContent.trim() : ''; }
    })();

    // 既存数量 input を取得（なければ作る）
    const qtyInput = form.querySelector('input.qty[name="quantity"]') || form.querySelector('input[name="quantity"]');
    const currentQty = (qtyInput && qtyInput.value) ? qtyInput.value : '1';

    // モーダルHTML（最小）
    const modalHtml = `
      <div class="showtime-modal">
        <div class="stm-head">
          <div class="stm-when">${heading}</div>
          <div class="stm-meta">
            ${priceEl ? `<div class="stm-price">${priceEl.outerHTML}</div>` : ``}
            ${stockEl ? `<div class="stm-stock ${stockEl.className.replace('stock','').trim()}">${stockEl.textContent.trim()}</div>` : ``}
          </div>
        </div>
        ${descEl ? `<div class="stm-desc">${descEl.outerHTML}</div>` : ``}
        <div class="stm-actions">
          <label class="stm-qty">
            <span>枚数</span>
            <input class="stm-qty-input" type="number" min="1" step="1" value="${currentQty}">
          </label>
          <button class="stm-add btn button alt">お買い物カゴに追加</button>
        </div>
      </div>
    `;

    // Featherlight で開く
    const fl = jQuery.featherlight(modalHtml, {
      variant: 'showtime-modal',
      afterOpen: function() {
        const $content = this.$content;
        const $qty     = $content.find('.stm-qty-input');
        const $add     = $content.find('.stm-add');

        // モーダルの枚数 → 本体フォームの数量へ反映
        $qty.on('input change', function(){
          if (!qtyInput) return;
          const v = parseInt(this.value, 10);
          if (!isNaN(v) && v > 0) qtyInput.value = v;
        });

        // 追加ボタン → 本体の「カートに入れる」をクリック
        $add.on('click', function(ev){
          ev.preventDefault();
          // 念のため数量を同期
          if ($qty.length && qtyInput) {
            const v = parseInt($qty.val(), 10);
            if (!isNaN(v) && v > 0) qtyInput.value = v;
          }
          // Wooの標準ボタンをクリック
          const addBtn = form.querySelector('.single_add_to_cart_button');
          if (addBtn) {
            addBtn.click();
          }
          // モーダルは閉じる（任意）
          fl.close();
        });
      }
    });
    // --- モーダル終わり ---
  }, true);
});
*/



console.log('[showtime] script.js loaded');

(function () {
  /**
   * Woo variations JSON を取得
   */
  function parseVariations(form) {
    try {
      const raw = form.getAttribute("data-product_variations");
      if (!raw) return [];
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  /**
   * Woo が jQuery 前提のことが多いので両方投げる
   */
  function triggerChange(el) {
    const evt = new Event("change", { bubbles: true });
    el.dispatchEvent(evt);
    if (window.jQuery) window.jQuery(el).trigger("change");
  }

  /**
   * selections: { "attribute_pa_showtime": "2026-02-12-1800", ... }
   */
  function matchesSelection(variation, selections) {
    const attrs = variation.attributes || {};
    for (const key in selections) {
      const val = selections[key];
      if (!val) continue;
      if ((attrs[key] || "") !== val) return false;
    }
    return true;
  }

  function getFormSelections(form) {
    const out = {};
    form.querySelectorAll('select[name^="attribute_"]').forEach((sel) => {
      out[sel.name] = sel.value || "";
    });
    return out;
  }

  function getAttributeSelectsInOrder(form) {
    // Woo の表示順に寄せる（=安定）
    return Array.from(form.querySelectorAll('select[name^="attribute_"]'));
  }

  function unique(arr) {
    return Array.from(new Set(arr));
  }

  /**
   * 追加属性 UI（ボタン群）を組み立てる
   */
  function buildButtons({ container, title, options, onClick }) {
    const wrap = document.createElement("div");
    wrap.className = "wc-showtime-attr";

    const h = document.createElement("h6");
    h.className = "wc-showtime-attr__title";
    h.textContent = title;
    wrap.appendChild(h);

    const ul = document.createElement("div");
    ul.className = "wc-showtime-attr__options";

    options.forEach((opt) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "wc-showtime-attr__btn";
      if (opt.disabled) btn.classList.add("is-disabled");
      if (opt.active) btn.classList.add("is-active");
      btn.disabled = !!opt.disabled;

      btn.innerHTML = `
        <span class="wc-showtime-attr__label">${opt.label}</span>
        ${opt.meta_html ? `${opt.meta_html}` : ""}
      `.trim();

      btn.addEventListener("click", () => {
        if (opt.disabled) return;
        onClick(opt.value);
      });

      ul.appendChild(btn);
    });

    wrap.appendChild(ul);
    container.appendChild(wrap);
  }

  /**
   * Wooの select を確実に非表示にする（multi のとき）
   */
  function hideWooSelects(form, showtimeSelectName) {
    // フォールバック（万一渡せてなくても showtime 行は残す）
    const showName = showtimeSelectName || "attribute_pa_showtime";

    form.querySelectorAll("table.variations tr").forEach((tr) => {
      const sel = tr.querySelector('select[name^="attribute_"]');
      if (!sel) return;

      if (sel.name === showName) {
        // showtime行：trは残す（独自UIがここに入ってるため）
        sel.style.display = "none";
        tr.style.display = ""; // 念のため明示
        return;
      }

      // showtime以外：行ごと隠す
      tr.style.display = "none";
    });

    // “クリア”リンクも隠す（必要なら）
    const reset = form.querySelector(".reset_variations");
    if (reset) reset.style.display = "none";
  }

  /**
   * showtime 変更時に他属性をリセット（multi のとき）
   */
  function resetOtherAttributes(form, showtimeSelect) {
    form.querySelectorAll('select[name^="attribute_"]').forEach((sel) => {
      if (sel.name === showtimeSelect.name) return;
      if (sel.value !== "") {
        sel.value = "";
        triggerChange(sel);
      }
    });
  }

  /**
   * 追加属性の「表示名」を作る（最低限）
   * 可能なら aria-label 等から拾う
   */
  function getNiceTitleForSelect(sel) {
    // variations テーブルの th.label の文言を優先して拾う（日本語属性でも安全）
    const td = sel.closest("td.value");
    if (td) {
      const tr = td.closest("tr");
      const label = tr ? tr.querySelector("th.label label") : null;
      const text = label ? label.textContent.trim() : "";
      if (text) return text;
    }

    // フォールバック
    return (
      sel.getAttribute("aria-label") ||
      (sel.dataset && sel.dataset.attribute_name) ||
      sel.name.replace(/^attribute_/, "")
    );
  }

  /**
   * multi（showtime×追加属性）UIの初期化
   */
  function initShowtimeUI(root) {
    const mode = root.getAttribute("data-mode") || "single";
    const targetSelectName = root.getAttribute("data-target-select"); // attribute_pa_showtime
    const extra = root.querySelector(".wc-showtime-extra");

    // variations_form を探す
    const form = root.closest("form.variations_form") || document.querySelector("form.variations_form");
    if (!form || !targetSelectName || !extra) return;

    const variations = parseVariations(form);

    const showtimeSelect = form.querySelector(`select[name="${CSS.escape(targetSelectName)}"]`);
    if (!showtimeSelect) return;

    /**
     * single：従来通り（showtimeクリック→hidden select更新）
     */
    if (mode === "single") {
      root.addEventListener("click", (e) => {
        const a = e.target.closest(".showtime-item");
        if (!a || a.classList.contains("is-disabled")) return;
        e.preventDefault();
        const val = a.getAttribute("data-value") || "";
        showtimeSelect.value = val;
        triggerChange(showtimeSelect);
      });
      return;
    }

    /**
     * multi：Woo select 非表示 + 追加属性UI生成
     */
    // hideWooSelects(form);
    hideWooSelects(form, showtimeSelect.name);

    function renderExtraUI() {
      extra.innerHTML = "";

      const selects = getAttributeSelectsInOrder(form);
      const selections = getFormSelections(form);

      const showtimeKey = showtimeSelect.name; // "attribute_pa_showtime"
      const showtimeVal = selections[showtimeKey] || "";

      // showtime 未選択なら何も出さない
      if (!showtimeVal) return;

      // showtime が一致する variation だけに絞る
      const inShowtime = variations.filter((v) =>
        matchesSelection(v, { [showtimeKey]: showtimeVal })
      );

      // showtime以外の属性select
      const extraSelects = selects.filter((s) => s.name !== showtimeKey);

      if (extraSelects.length === 0) return;

      // 追加属性が1つだけなら、そのボタンに price/stock を表示してOK
      const showMetaPerOption = extraSelects.length === 1;

      extraSelects.forEach((sel) => {
        const attrName = sel.name; // "attribute_pa_seat" 等
        const currentVal = selections[attrName] || "";

        // そのshowtimeの中で存在する候補値（slug）を抽出
        const values = unique(
          inShowtime
            .map((v) => (v.attributes ? v.attributes[attrName] : ""))
            .filter((x) => x)
        );

        // 候補が無ければ UI 出さない
        if (values.length === 0) return;

        const options = values.map((value) => {
          // 既選択＋この値 で成立する variation があるか
          const nextSel = { ...selections, [attrName]: value };
          const candidates = inShowtime.filter((v) => matchesSelection(v, nextSel));
          const has = candidates.length > 0;
          const active = currentVal === value;

          let meta_html = "";

          if (showMetaPerOption && has) {
            // 代表（通常1件の想定）
            const v = candidates[0];

            const priceHtml = v.price_html || "";
            const inStock = v.is_in_stock !== false;

            // max_qty は Woo が入れてくれることが多い
            const maxQty = (typeof v.max_qty !== "undefined") ? v.max_qty : null;
            if (priceHtml) meta_html += `${priceHtml}`;
            /*
            meta_html += inStock
              ? `<span class="meta-stock">在庫あり</span>`
              : `<span class="meta-stock">在庫なし</span>`;

            if (maxQty !== null && maxQty !== "" && maxQty !== false) {
              meta_html += `<span class="meta-qty">残 ${maxQty}</span>`;
            }
            */
            const stockClass = inStock ? 'in-stock' : 'out-of-stock';
            const stockAttr  = (maxQty !== null && maxQty !== "" && maxQty !== false)
              ? ` data-stock="${maxQty}"`
              : '';

            meta_html += `<span class="stock ${stockClass}"${stockAttr}></span>`;

          }

          return {
            value,
            label: value, // 表示名にしたければ後で term map を渡して変換可能
            disabled: !has,
            active,
            meta_html
          };
        });

        buildButtons({
          container: extra,
          title: getNiceTitleForSelect(sel),
          options,
          onClick: (value) => {
            sel.value = value;
            triggerChange(sel);

            // 次の属性がある場合に備えて再描画（候補の絞り込み）
            // Woo側が found_variation などを更新するので、少し待つ
            setTimeout(renderExtraUI, 0);
          }
        });
      });
    }

    // showtime リストクリック
    root.addEventListener("click", (e) => {
      const a = e.target.closest(".showtime-item");
      if (!a || a.classList.contains("is-disabled")) return;
      e.preventDefault();

      const val = a.getAttribute("data-value") || "";
      showtimeSelect.value = val;
      triggerChange(showtimeSelect);

      // ★重要：showtime 変更時に他属性をリセット（誤確定防止）
      resetOtherAttributes(form, showtimeSelect);

      // 追加属性UIを描画
      renderExtraUI();
    });

    // select 側変更にも追従（戻る/プリセット/初期表示）
    form.addEventListener("change", (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('select[name^="attribute_"]')) {
        renderExtraUI();
      }
    });

    // 初期描画（URLプリセット等）
    renderExtraUI();
  }

  document.addEventListener("DOMContentLoaded", () => {
    const lists = document.querySelectorAll(".wc-showtime-list");
    console.log('[showtime] found lists:', lists.length);
    lists.forEach(initShowtimeUI);
  });
})();
